import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import UnitTable from '../../components/UnitTable/UnitTable';
import { getUnitRequestAction } from '../../store/unit/unitActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';

const Unit = ({ unitList, unitData, getUnitRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getUnitRequest({});
  }, [getUnitRequest]);

  const handleCreateUnit = () => {
    navigate('/unit/create');
  };

  return (
    <div className="unit-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('units')}</div>
        <UnitTable unitList={unitList} unitData={unitData} />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateUnit}
        title={t('createUnit')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  unitData: state.unitReducer.unitData,
  unitList: state.unitReducer.unitList,
});

const mapDispatchToProps = (dispatch) => ({
  getUnitRequest: (payload) => dispatch(getUnitRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Unit);
